export default __webpack_public_path__ + "static/media/yellowloadingcircle.8f8f06ac.svg";